import Anthropic from '@anthropic-ai/sdk';

const apiKey = import.meta.env?.VITE_ANTHROPIC_API_KEY;

if (!apiKey) {
  console.warn('Anthropic API key not found. Claude features will not work.');
}

let anthropic = null;

try {
  if (apiKey) {
    anthropic = new Anthropic({
      apiKey: apiKey,
      dangerouslyAllowBrowser: true
    });
  }
} catch (error) {
  console.error('Failed to initialize Anthropic client:', error);
}

export default anthropic;